var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"dense":"","server-items-length":_vm.total,"options":_vm.options,"footer-props":{
      'items-per-page-options': [25, 50],
      'items-per-page-text': 'Mostrar',
    },"loading":_vm.loading,"loading-text":"Carregando..."},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.user_id",fn:function(ref){
    var item = ref.item;
return [_c('small',[_vm._v(_vm._s(_vm.professionalClassCouncilValue(_vm.getUserById(item.user_id))))])]}},{key:"item.when",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.when))+" ")]}},{key:"item.action",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.handleAction(item.action))+" ")]}}],null,true)}),_c('errors-messages',{attrs:{"errors":_vm.errors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }